import { Container, Grid, Typography, Button } from "@pmberjaya/cloudbank-ui";
import { useRouter } from "next/router";
import React from "react";
import Section from "../Section";

const CallMe = () => {
  const router = useRouter();
  return (
    <Section>
      <Grid xs={12} className="pb-2">
        <h2 className="text-heading-h2 text-center">
          ADA PERTANYAAN? <br /> HUBUNGI LANGSUNG HELP CENTER KAMI
        </h2>
      </Grid>
      <Grid xs={6} className="mx-auto">
        <Button
          variant="outlined"
          fullWidth
          size="large"
          className="text-center"
          onClick={() => router.push("/contact")}
        >
          Hubungi Kami
        </Button>
      </Grid>
    </Section>
  );
};

export default CallMe;
